module.exports = new __parcel__URL__("poison_claw.01842c64.png").toString();